module.exports = __webpack_public_path__ + "img/Logo-32.8500fb11.svg";